import { FC } from "react";
import Chip from "@mui/material/Chip";
import { Stack, Tooltip, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

interface BillingCostNoDataChipProps {
  title: string;
  tooltipTitle: string;
}

export const BillingCostNoDataChip: FC<BillingCostNoDataChipProps> = ({
  title,
  tooltipTitle,
}) => {
  return (
    <Chip
      sx={{
        height: 28,
      }}
      label={
        <Stack direction="row" alignItems="center" spacing={0.5}>
          <Typography variant="inherit">{title}</Typography>
          <Tooltip arrow placement="top" title={tooltipTitle}>
            <InfoOutlinedIcon fontSize="small" color="action" />
          </Tooltip>
        </Stack>
      }
    />
  );
};
